import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import Line from '../../../../packages/kiti/components/helpers/Line'
import XNumberInput from '../../../../packages/kiti/components/form/NumberInput'

const SellInfoSection = () => {
  const { t } = useTranslation('editStocks')
  return (
    <>
      <Separator weight={2} />
      <Title size="small" bold color="dark3">
        {t('sections.sellInfo')}
      </Title>
      <Line />
      <Separator weight={2} />
      <Grid paddingGutter={0.5} wrap>
        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.salesPrice')} field="salesPrice" Input={XNumberInput} />
        </Col>
        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.maxDiscount')} field="maxDiscount" Input={XNumberInput} />
        </Col>

        <Col width="33%" wrapOn="sm">
          <FormItem label={t('fields.salesTax')} field="salesTax" Input={XNumberInput} />
        </Col>
      </Grid>
    </>
  )
}

export default SellInfoSection
